import { useProductRefreshExperienceEnabled } from './useProductRefreshExperienceEnabled'
import { UI_THEME_FLAG_KEY } from '../shell_layout/shellConstants'

/**
 * Brand 2026 UI tokens (`html[data-theme]` via `useBodyStyles`).
 * True when the beta gate passes and `ap_rebrand_ui_theme` is on or the user is in the global cohort.
 */
export function useProductRefreshUiTheme(): boolean {
  return useProductRefreshExperienceEnabled(UI_THEME_FLAG_KEY)
}
